<template>
  <v-container fluid class="primary_dark">
    <v-layout mt-10>
      <v-flex xs12>
        <h1
          class="
            white--text
            text-center
            my-6
            display-2
            font-weight-bold
            customFont
          "
        >
          Sucursales
        </h1>
        <v-item-group v-model="toggle_exclusive">
          <v-container>
            <v-row class="justify-center align-center">
              <v-col
                v-for="(item, index) in options"
                :key="index"
                cols="12"
                sm="12"
                md="3"
                lg="3"
              >
                <v-item v-slot:default="{ active, toggle }" :value="item.value">
                  <v-card
                    flat
                    tile
                    class="d-flex align-center transparent customFont"
                    :class="{ 'card-selected': active }"
                    height="50"
                    @click="toggle"
                  >
                    <v-card-text>
                      <h3 class="white--text text-center mb-2">
                        {{ item.text }}
                      </h3>
                    </v-card-text>
                  </v-card>
                </v-item>
              </v-col>
            </v-row>
          </v-container>
        </v-item-group>
        <v-container>
          <v-row mx-12>
            <v-col v-for="item in tagsFiltered" :key="item.id">
              <v-row my-12>
                <v-col cols="12" md="6">
                  <h5 class="text-uppercase font-weight-bold white--text mb-2">
                    Responsable de la UNE:
                  </h5>
                  <p class="white--text body-1">{{ item.manager }}</p>
                  <h5 class="text-uppercase font-weight-bold white--text mb-2">
                    Domicilio:
                  </h5>
                  <p class="white--text body-1">{{ item.address }}</p>
                  <h5 class="text-uppercase font-weight-bold white--text mb-2">
                    Teléfono:
                  </h5>
                  <p class="white--text body-1">{{ item.telephone }}</p>
                  <h5 class="text-uppercase font-weight-bold white--text mb-2">
                    Horario:
                  </h5>
                  <p class="white--text body-1">{{ item.schedule }}</p>
                  <h5 class="text-uppercase font-weight-bold white--text mb-2">
                    Email:
                  </h5>
                  <a class="white--text" :href="'mailto:' + item.email">{{
                    item.email
                  }}</a>
                </v-col>
                <v-col cols="12" md="6">
                  <iframe
                    :src="item.location"
                    :height="$vuetify.breakpoint.mdAndUp ? '450' : '400'"
                    width="100%"
                    frameborder="0"
                    style="border: 0"
                    allowfullscreen
                  ></iframe>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<style lang="scss" scoped>
.absolute {
  left: 0;
  position: absolute;
  bottom: 0;
}
.card-selected {
  border-bottom: 2px solid white !important;
}
.transparent {
  background-color: transparent;
}
.customFont {
  font-family: "Eras Medium ITC" !important;
}
a.primary--text {
  color: #e5e9ec !important;
  caret-color: #f4f4f4 !important;
}
</style>
<script>
export default {
  data() {
    return {
      toggle_exclusive: "nayarit",
      posts: [
        {
          id: 0,
          manager: "Lic. Carlos Alberto Zermeño Cuevas",
          address:
            "Carretera Tepic-Puerto Vallarta No. Ext. 5415, Int. A-4, Col. Las juntas, CP. 48291, Puerto Vallarta, Jalisco.",
          telephone: "(322) 223-9437, (322) 223-9481 y (322) 223-9572.",
          email: "ifa_une_pv@capitalica.com.mx",
          tag: "jalisco",
          description:
            "Conoce nuestras recomendaciones para mantener un equilibrio entre tu familia y tu licenciatura",
          location:
            "https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d933.109905543758!2d-105.2435915!3d20.6923653!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842145dff8703be3%3A0x18b8b86519dfb8a1!2sPlaza%20Las%20Juntas%20-%20Centro%20de%20Dise%C3%B1o!5e0!3m2!1ses!2smx!4v1653680512542!5m2!1ses!2smx",
        },
        {
          id: 1,
          manager: "Lic. José Ramón Bobadilla Rojas",
          address:
            "Calle: Avenida México 194 sur, No. interior: segundo piso, Col. Centro, CP:63000, Tepic Nayarit, México.",
          telephone: "(311) 133-4529 al 32, (311) 133-4542 y (311) 688-2202.",
          email: "ifa_une@capitalica.com.mx",
          tag: "nayarit",
          schedule: "9:00 a.m. a 17:00 p.m",
          description:
            "Conoce nuestras recomendaciones para mantener un equilibrio entre tu familia y tu licenciatura",
          location:
            "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d928.0199603793365!2d-104.89461039999999!3d21.5045924!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x842736fd1ba391c9%3A0x42787dba2aba4c8e!2sAv%20M%C3%A9xico%20Nte%20194%2C%20Centro%2C%2063000%20Tepic%2C%20Nay.!5e0!3m2!1ses-419!2smx!4v1663101440907!5m2!1ses-419!2smx",
        },
      ],
      options: [
        { text: "Tepic, Nayarit", value: "nayarit" },
        // { text: "Puerto Vallarta, Jalisco", value: "jalisco" },
      ],
    };
  },
  computed: {
    tagsFiltered() {
      return this.posts.filter((item) => {
        return item.tag.includes(this.toggle_exclusive.toLowerCase());
      });
    },
  },
};
</script>
